import React, { Fragment } from 'react'
import { ResponsiveEmbed } from 'react-bootstrap'
import { useInView } from 'react-intersection-observer'

const Embed = ({ file }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })

  let src = 'https://player.vimeo.com/video'
  let embed = null

  if (file.data?.embed?.url && file.data.embed.url.indexOf('youtube.com') !== -1) {
    src = 'https://www.youtube.com/embed'
  }

  if (file.embed) {
    embed = (
      <iframe
        allow="autoplay; fullscreen"
        allowFullScreen
        frameBorder="0"
        src={`${src}/${file.embed}`}
      />
    )
  } else if (file.data?.full_url) {
    embed = (
      <video controls={1} autoPlay={1}>
        <source src={file.data.full_url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    )
  }

  return (
    <div ref={ref}>
      <ResponsiveEmbed aspectRatio="16by9">{inView ? embed : <Fragment />}</ResponsiveEmbed>
    </div>
  )
}

export default React.memo(Embed)
